export enum PlanMediaType {
  CAPTURE_HD = 'CAPTURE_HD',
  CAPTURE_360 = 'CAPTURE_360',
  CAPTURE_AUTO = 'CAPTURE_AUTO',
  CAPTURE_2D = 'CAPTURE_2D',
  CAPTURE_3D = 'CAPTURE_3D',
  DEFAULT = 'default'
}
